import { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useAppUpdateStore } from '@/lib/version-check';

/** Avisa que há um deploy novo do front e oferece recarregar a página. */
export function UpdateAvailableModal() {
  const updateAvailable = useAppUpdateStore((s) => s.updateAvailable);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (updateAvailable) setOpen(true);
  }, [updateAvailable]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Nova versão disponível</DialogTitle>
          <DialogDescription>
            O sistema foi atualizado. Clique em Atualizar para carregar a versão mais recente. Se
            precisar salvar algo antes, a página será atualizada automaticamente em 10 minutos.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)}>
            Depois
          </Button>
          <Button onClick={() => window.location.reload()}>
            <RefreshCw className="mr-2 h-4 w-4" />
            Atualizar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
